'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleModal = undefined;

var _reactRedux = require('react-redux');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _decorator = require('helpers/decorator');

var _Sagas = require('decorators/Sagas/Sagas');

var _ReservationModal = require('./ReservationModal');

var _Reservation = require('../Reservation.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = {};

var mapDispatchToProps = {
  requestReservation: _Reservation.requestReservation
};

var LocaleModal = exports.LocaleModal = (0, _decorator.decorateWith)((0, _Modal2.default)(modalConfig), (0, _Sagas.withSagas)({ watch: _Reservation.watchRequestReservation }), (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _decorator.withName)('ReservationModal'))(_ReservationModal.ReservationModal);